<template>
    <div class="login-form-wrapper">
        <div class="reset-form">
            <form @submit.prevent="submit">
                <p class="form-description">
                    Ingrese su correo electrónico para poder restablecer su contraseña.
                    Te enviaremos un correo electrónico con las instrucciones a seguir.
                </p>

                <div class="field">
                    <label>Número de Proveedor</label>
                    <div class="control is-bigger has-icon">
                        <input class="input" type="text" name="cliente_id" id="cliente_id" v-model="cliente_id">
                        <div class="form-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-hash"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>
                        </div>
                    </div>
                </div>

                <div class="field">
                    <label>Email</label>
                    <div class="control is-bigger has-icon">
                        <input class="input" type="email" name="email" id="email" v-model="email">
                        <div class="form-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        </div>
                    </div>
                </div>

                <div class="button-wrap">
                    <button type="submit" class="button primary-button upper-button raised is-fullwidth is-rounded">Restablecer Contraseña</button>
                </div>

            </form>

            <small class="has-text-danger"><em>{{errors}}</em></small>
            <small class="has-text-success"><em>{{message}}</em></small>

            <div class="back-link has-text-centered">
                <router-link tag="a" :to="{name: 'auth.login'}">Volver al Login</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'recover',
    created(){
        this.clearAuthErrors()
    },
    components: {
        //
    },
    computed: {
        ...mapGetters({
            errors: 'auth/errors'
        }),
    },
    data(){
        return{
            message: '',
            email: '',
            cliente_id: ''
        }
    },
    methods:{
        ...mapActions({
            recover: 'auth/recover',
            clearAuthErrors: 'auth/clearAuthErrors',
        }),

        submit(){
            this.recover( { email: this.email, cliente_id: this.cliente_id } )
            .then( (response) => {
                this.message = response;
                this.email = '';
                this.cliente_id = '';
                setTimeout(() => this.message = '', 5000);
            }).catch(() => {
                console.log("Error al resetear clave");
            })
        }
    }
}
</script>
